export default __webpack_public_path__ + "static/media/thumb_up_icon.84db8136.svg";